import React, { useEffect, useState } from "react";
import parse from 'html-react-parser';
import { Link } from "react-router-dom";
import axios from "axios";
import { api_url, media_url } from "../../url";
import Loading from "../Loading/Loading";
import NoData from "../PortalComponents/NoData/NoData";

const NewsSection = () => {
  const [gettingNews, setGettingNews] = useState(true);
  const [news, setNews] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const getNews = async (url = `${api_url}website/news/`, search = "") => {
    setGettingNews(true);
    const config = {
      header: {
        'Content-Type': 'application/json'
      },
      params: {
        search: search
      }
    }
    await axios.get(url, config).then((response) => {
      setNews(response.data.results || []);
      setNextUrl(response.data.next);
      setPrevUrl(response.data.previous);
      setGettingNews(false);
    }).catch((error) => {
      setGettingNews(false);
    })
  }

  useEffect(() => {
    getNews();
  }, [])

  const handleSearch = (e) => {
    e.preventDefault();
    getNews(`${api_url}news/`, searchQuery);
  }

  return (
    <div id="news" className="max-w-[1440px] mx-auto px-4 py-8">
      {/* Search Section */}
      <div className="mb-10 flex justify-center">
        <form onSubmit={handleSearch} className="flex gap-2.5 w-full max-w-2xl">
          <input
            type="text"
            placeholder="Search news by title..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="flex-1 px-5 py-3 border border-[#021D53]/20 rounded-xl font-['Inter'] text-sm outline-none transition-colors duration-300 focus:border-[#021D53]"
          />
          <button 
            type="submit" 
            className="px-6 py-3 bg-[#021D53] text-white rounded-xl font-['Inter'] font-semibold cursor-pointer transition-colors duration-300 hover:bg-[#1E438B]"
          >
            Search
          </button>
        </form>
      </div>

      {
        gettingNews ? (
          <Loading />
        ) : (
          <>
            {/* News Items Grid */}
            <div className="grid xl:grid-cols-4 md:grid-cols-2 gap-5 lg:justify-start">
              {news.map((newsItem, index) => (
                <div 
                  className=" border border-[#021D53]/20 rounded mb-10 overflow-hidden transition-all duration-300 hover:shadow-lg" 
                  key={index}
                >
                  <div
                    className="h-80 bg-cover bg-center bg-no-repeat"
                    style={{ backgroundImage: `url(${media_url}${newsItem?.thumbnail})` }}
                  >
                  </div>
                  <div className="p-5 mt-5 flex flex-col gap-2">
                    <div className="text-[14.11px] uppercase text-[#464646] font-['Inter']">
                      {newsItem.date}
                    </div>
                    <div className="font-bold text-base text-[#021D53] font-['Inter']">
                      {newsItem.title}
                    </div>
                    <div className="text-[14.11px] leading-[14.62px] text-[#464646] font-['Inter']">
                      {newsItem.details ? parse(newsItem.details.slice(0, 200)) : ""}...
                    </div>
                    <Link 
                      to={`/news-events/news/${newsItem?.slug}`}
                      className="text-[#021D53] underline font-['Inter'] font-semibold hover:text-[#1E438B] transition-colors"
                    >
                      READ MORE
                    </Link>
                  </div>
                </div>
              ))}
            </div>
            
            {/* Pagination Controls */}
            <div className="flex justify-center gap-5 mt-12 mb-5">
              <button 
                disabled={!prevUrl} 
                onClick={() => getNews(prevUrl, searchQuery)}
                className="px-8 py-2.5 bg-transparent border border-[#021D53] text-[#021D53] rounded-lg font-['Inter'] font-semibold cursor-pointer transition-all duration-300 disabled:border-[#ccc] disabled:text-[#ccc] disabled:cursor-not-allowed enabled:hover:bg-[#021D53] enabled:hover:text-white"
              >
                Previous
              </button>
              <button 
                disabled={!nextUrl} 
                onClick={() => getNews(nextUrl, searchQuery)}
                className="px-8 py-2.5 bg-transparent border border-[#021D53] text-[#021D53] rounded-lg font-['Inter'] font-semibold cursor-pointer transition-all duration-300 disabled:border-[#ccc] disabled:text-[#ccc] disabled:cursor-not-allowed enabled:hover:bg-[#021D53] enabled:hover:text-white"
              >
                Next
              </button>
            </div>
          </>
        )
      }

      {
        !gettingNews && news.length <= 0 && (
          <NoData />
        )
      }

      {/* Newsletter Section */}
      <div className="w-full my-12 mx-auto bg-gradient-to-r from-black to-[#021D53] flex flex-col md:flex-row items-center justify-center p-12 md:p-[71px_52px] gap-10 md:gap-[70px] rounded-2xl shadow-xl">
        <div className="flex-[2]">
          <h3 className="text-[33.18px] font-bold text-white mb-2.5 font-['Inter']">
            Newsletter
          </h3>
          <p className="text-white text-[13px] text-justify font-normal leading-relaxed opacity-90 font-['Inter']">
            Stay in the know and be the first to hear about the latest news, trends, and exciting developments in your favorite niche! 
          </p>
        </div>
        <div className="flex-1 w-full md:w-auto">
          <form onSubmit={(e)=>e.preventDefault()} className="flex flex-col gap-2 items-center">
            <input
              type="email"
              name="email"
              id="email"
              placeholder="Enter your email address here"
              className="h-12 w-full md:w-[309px] px-4 flex items-center justify-center text-center bg-transparent border border-white text-white font-['Inter'] placeholder:text-white/70 placeholder:text-[13.33px] placeholder:font-medium outline-none rounded-md focus:bg-white/5 transition-all"
            />
            <input 
              type="submit" 
              value="SUBSCRIBE NOW" 
              className="w-full md:w-[309px] h-[51px] bg-[#1E438B] text-white text-base font-bold font-['Inter'] leading-[19.36px] border-none cursor-pointer rounded-md transition-all hover:bg-[#1c48a0] active:scale-95"
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewsSection;
